module.exports = "https://coursera_assets.s3.amazonaws.com/images/7da4aec636c6e303173080f2aaa88878.jpg";